import { ReactElement } from 'react'
import SteelBasePlateConfigFormFields from '@editor/components/CheckSettingsFormFields/SteelBasePlateConfigFormFields'
import MultiEditCheckSettings from '../MultiEditCheckSettings'
import { MultiEditCheckSettingsElement } from '../MultiEditCheckSettings/types'
import {
  buildSteelBasePlateSettingsRow,
  getEditableSteelBasePlateSettings,
  mergeSteelBasePlateSettings,
  normalizeSteelBasePlateSettings,
  steelBasePlateSettingsColumns,
} from './utils'

interface Props {
  elements: MultiEditCheckSettingsElement[]
}

const MultiEditSteelBasePlate = ({ elements }: Props): ReactElement => (
  <MultiEditCheckSettings
    elements={elements}
    sectionKey="steelConfig"
    settingsLabel="Fußpunkt-Einstellungen"
    getSettings={getEditableSteelBasePlateSettings}
    normalizeSettings={normalizeSteelBasePlateSettings}
    mergeSettings={mergeSteelBasePlateSettings}
    differingSettingsMessage="Elemente haben unterschiedliche Fußpunkt-Einstellungen"
    settingsColumns={steelBasePlateSettingsColumns}
    buildSettingsRow={buildSteelBasePlateSettingsRow}
    data-cy="steel-base-plate-form"
    changeButtonDataCy="steel-base-plate-change-button"
    fields={<SteelBasePlateConfigFormFields memberCheckSettingsSelectedPath="sharedSettings" />}
  />
)

export default MultiEditSteelBasePlate
